import { render, staticRenderFns } from "./search_teacher.vue?vue&type=template&id=720542bb&scoped=true"
import script from "./search_teacher.vue?vue&type=script&lang=js"
export * from "./search_teacher.vue?vue&type=script&lang=js"
import style0 from "./search_teacher.css?vue&type=style&index=0&id=720542bb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720542bb",
  null
  
)

export default component.exports